import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import { Provider } from 'react-redux';
import Login from './componentes/login';
import App from './componentes/app';
import CambioClave from './componentes/cambioClave';
import store from './store';
import { existeSesion } from './funciones_globales/manejosesion';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => ( existeSesion()? 
        ( <Component {...props}/>)
            :( <Redirect to={{
                pathname: '/login',
                state: { from: props.location }
            }}/>
        )
    )}/>
)

ReactDOM.render((    
    <Provider store={store}>
        <BrowserRouter>
            <Switch>
                <Route exact path="/login" name="Inicio de Sesion" component={Login}/>
                <Route path="/cambioclave" component={CambioClave}/>
                <PrivateRoute path="/" component={App}/>
            </Switch>
        </BrowserRouter>
    </Provider>
), document.getElementById('root'));